import { EnvironmentConfig } from '@/types/environment-config';

const DEV_ENVIRONMENT_CONFIG: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-dev.gls-group.net',
    VITE_AZURE_AD_CLIENT_ID: '906d4472-f0b8-456e-88b4-8b4edc0c0c10'
};

const STAGE_ENVIRONMENT_CONFIG: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-qas.gls-group.net',
    VITE_AZURE_AD_CLIENT_ID: '906d4472-f0b8-456e-88b4-8b4edc0c0c10'
};

const SANDBOX_ENVIRONMENT_CONFIG: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-sandbox.gls-group.net',
    VITE_AZURE_AD_CLIENT_ID: 'f64f7d8a-0c37-4941-abde-d3a7727e3528'
};

const PROD_ENVIRONMENT_CONFIG: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api.gls-group.net',
    VITE_AZURE_AD_CLIENT_ID: 'f64f7d8a-0c37-4941-abde-d3a7727e3528'
};

export { DEV_ENVIRONMENT_CONFIG, STAGE_ENVIRONMENT_CONFIG, SANDBOX_ENVIRONMENT_CONFIG, PROD_ENVIRONMENT_CONFIG };
